import React from 'react'
import styled from 'styled-components';


function ForgotPassword() {

    document.title = "Reset account password | Lehumo";

    return (
        <>
            <FormContainer>
                <center>
                    <form>
                        <h3>Provide your account information</h3>
                        <input type="email" name="email" placeholder="Email address" required />
                        <input type="number" name="phone" placeholder="Phone number" required /><br />
                        <button type="submit" name="submit">Continue</button>
                    </form>
                </center>
            </FormContainer>
        </>
    )
}

export default ForgotPassword

const FormContainer = styled.div`
    background: var(--background);
    width: 60%;
    height: 300px;
    margin: 100px auto;
    border-radius: 10px;
    border: 3px solid var(--primary);
    justify-content: center;
    align-item: center;
    font-family: 'Poppins', sans-serif;

    @media (max-width: 768px) {
        background: transparent;
        width: 95%;
        height: 300px;
        border: none;
    
    }

    form {
        padding-top: 30px;
    }

    
    input {
        border: 1px solid var(--primary);
        background: transparent;
        border-radius: 4px;
        width: 300px;
        height: 50px;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        outline: none;
        justify-content: space-between;
        margin-left: 5px;

        @media (max-width: 768px) {
            width: 300px;
        }
    }

    button {
        width: 600px;
        height: 50px;
        border-radius: 4px;
        background-color: var(--primary);
        border: none;
        color: #fff;
        text-transform: uppercase;
        margin-top: 5px;
        font-weight: 600;
        font-size: 14px;

        @media (max-width: 768px) {
            width: 300px;
        }
    }

    p {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: bold;
    }

    h3 {
        margin-top: 40px;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;

        @media (max-width: 768px) {
            text-align: center;
            margin-left: 0px;
        }
    }
`
